const MAX_CAPTION_CHARS = 200;
const CAPTION_HOLD_MS = 1800;

/** Keeps captions readable across audio gaps, then lets ongoing task status reclaim the line. */
export class VoiceCaptionDisplay {
  #text = '';
  #stale = false;
  #speaking = false;
  #working = false;
  #disposed = false;
  #expiry: ReturnType<typeof setTimeout> | undefined;
  #onCaption: (text: string) => void;

  constructor(onCaption: (text: string) => void) {
    this.#onCaption = onCaption;
  }

  append(delta: string, startsNewCaption = this.#stale): void {
    if (this.#disposed) {
      return;
    }
    if (startsNewCaption) {
      this.#text = '';
    }
    this.#stale = false;
    this.#text = (this.#text + delta).slice(-MAX_CAPTION_CHARS);
    this.#onCaption(this.#text);
    this.#scheduleExpiry();
  }

  setSpeaking(speaking: boolean): void {
    if (this.#disposed) {
      return;
    }
    this.#speaking = speaking;
    if (!speaking) {
      this.#stale = true;
    }
    this.#scheduleExpiry();
  }

  setWorking(working: boolean): void {
    if (this.#disposed || this.#working === working) {
      return;
    }
    this.#working = working;
    this.#scheduleExpiry();
  }

  clear(): void {
    if (this.#disposed) {
      return;
    }
    clearTimeout(this.#expiry);
    this.#stale = false;
    if (!this.#text) {
      return;
    }
    this.#text = '';
    this.#onCaption('');
  }

  dispose(): void {
    this.#disposed = true;
    clearTimeout(this.#expiry);
  }

  #scheduleExpiry(): void {
    clearTimeout(this.#expiry);
    if (this.#working && !this.#speaking && this.#text) {
      this.#expiry = setTimeout(() => this.clear(), CAPTION_HOLD_MS);
    }
  }
}
